import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Target } from "lucide-react";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/common-number", label: "Common Number" },
  { to: "/previous-result", label: "Previous Result" },
  { to: "/about-us", label: "About" },
  { to: "/contact-us", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-3 py-2 text-sm font-semibold rounded-lg transition-colors duration-200 ${
      isActive ? "text-red-600 bg-red-50" : "text-slate-700 hover:text-red-600 hover:bg-slate-50"
    }`;

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="site-logo" className="flex items-center gap-2 group">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg bg-red-600 text-white">
              <Target size={20} strokeWidth={2.5} />
            </span>
            <span className="font-oswald text-xl sm:text-2xl font-bold tracking-tight text-slate-900 leading-none">
              Night Teer
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} className={linkClass} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <button
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg text-slate-700 hover:bg-slate-100"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden border-t border-slate-200 bg-white px-4 py-3 flex flex-col gap-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              onClick={() => setOpen(false)}
              className={linkClass}
              data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
